import * as _4 from 'lodash4';
import { Strategy } from 'utility-ts-strategy';
import { InTakeSurveyAnswer } from '../builders/ap_intake_survey_answer_builder';
import { IIntakeSurveyApiAnswer, IInTakeSurveyQuestionMeta } from '../builders/ap_intake_survey_builder';
import { IInTakeSurveyQuestionChoice } from '../builders/ap_intake_survey_question_choice_builder';

const radioInputQuestionAnswer = (
  question: IInTakeSurveyQuestionMeta,
  choices: IInTakeSurveyQuestionChoice[],
  answers: InTakeSurveyAnswer[]
) => {
  const _answersGroupByQuesID = _4.groupBy(answers, 'question_id');
  const answerForQuestion: IIntakeSurveyApiAnswer[] = _answersGroupByQuesID[question.id];
  return { ..._4.find(choices, { nk: _4.get(answerForQuestion, '[0]value') }) };
};

const checkboxInputQuestionAnswer = (
  question: IInTakeSurveyQuestionMeta,
  choices: IInTakeSurveyQuestionChoice[],
  answers: InTakeSurveyAnswer[]
) => {
  const _answersGroupByQuesID = _4.groupBy(answers, 'question_id');
  const _answersForQuestion: IIntakeSurveyApiAnswer[] = _answersGroupByQuesID[question.id];

  let answersForQuestion: IInTakeSurveyQuestionChoice[] = [];
  answersForQuestion = _4.map(_answersForQuestion, (answer: IIntakeSurveyApiAnswer) => ({
    ..._4.find(choices, { nk: answer.value })
  }));
  return answersForQuestion;
};

export const IntakeSurveyAnswerStrategy = new Strategy({
  radio: radioInputQuestionAnswer,
  checkbox: checkboxInputQuestionAnswer
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/strategies/intake_survey_answer_strategy.ts